<template>
  <div id="acs-por-cidadao">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            linkvideoajuda="https://www.youtube.com/embed/fFtFeed-d5A"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-6">
          <div class="form-group">
            <label for="">Nome do cidadão ou CPF</label>
            <input
              type="text"
              class="form-control"
              placeholder=""
              v-model="termo"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="">Data de nascimento</label>
            <input type="date" class="form-control" v-model="dt_nascimento" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6">
          <div class="form-group">
            <button class="btn btn-submit" v-on:click="buscarAcsPorCidadao()">
              <i class="icofont-search-user"></i> Buscar
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item"></div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="Cidadao"
              >
              </download-files>
            </div>
          </div>
          <tabela
            :loading="loading"
            :headers="headersCidadao"
            :cadastros="displayedCadastros"
            :codIbge="cod_ibge"
            @detalhar-cidadao="detalharCidadao"
            @filterSearch="filterSearch($event)"
          >
          </tabela>
        </div>
      </div>
    </div>
    <Footer />
    <b-modal id="modal-acs-cidadao" title="" centered hide-footer size="xl">
      <h3 class="mb-3">{{ selectedItemToModal.no_cidadao }}</h3>
      <p>
        <b>MA:</b> {{ selectedItemToModal.micro_area }} &nbsp;&nbsp;&nbsp;
        <b>Profissional ACS:</b>
        {{ selectedItemToModal.no_profissional }} &nbsp;&nbsp;&nbsp;
        <b>Equipe:</b>
        {{ selectedItemToModal.no_unidade_saude }} &nbsp;&nbsp;&nbsp; <br />
        <b>INE: </b>{{ selectedItemToModal.nu_ine }} &nbsp;&nbsp;&nbsp;
        <b>Saiu?</b>
        {{ selectedItemToModal.saiu != '3' ? 'Sim' : '' }} &nbsp;&nbsp;&nbsp;
        <b> Atualização:</b>
        {{
          selectedItemToModal.dt_atualizado != undefined
            ? formatDate(selectedItemToModal.dt_atualizado)
            : ''
        }}
        &nbsp;&nbsp;&nbsp;
        <b>CFCP: </b> {{ selectedItemToModal.cfcp }}
      </p>
      <b-tabs content-class="mt-3">
        <b-tab
          title="Cadastros"
          active
          @click="detalharCidadao(selectedItemToModal, 'cadastros')"
        >
          <tabela
            :loading="loadingTabCadastros"
            :headers="headersCadastros"
            :cadastros="selectedItemModalCadastros"
          >
          </tabela>
        </b-tab>
        <b-tab
          title="Atendimentos"
          @click="detalharCidadao(selectedItemToModal, 'atendimentos')"
        >
          <div class="row c-select-indicator">
            <div class="col-sd-12 col-md-6 col-lg-5 col-xl-4">
              <vue-select
                :options="atendimentos.items"
                label="label"
                placeholder="Período"
                v-model="atendimentos.selected"
                @input="
                  handlePeriodAndIndicator($event, atendimentos.indicator)
                "
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela
            :loading="loadingTabAtendimentos"
            :headers="headersAtendimentos"
            :cadastros="selectedItemModalAtendimentos"
            :enabledSearch="true"
            labelSearch="Tipo"
          >
          </tabela>
        </b-tab>
        <b-tab
          title="Odonto"
          @click="detalharCidadao(selectedItemToModal, 'odonto')"
        >
          <div class="row c-select-indicator">
            <div class="col-sd-12 col-md-6 col-lg-5 col-xl-4">
              <vue-select
                :options="odonto.items"
                label="label"
                placeholder="Período"
                v-model="odonto.selected"
                @input="handlePeriodAndIndicator($event, odonto.indicator)"
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela
            :loading="loadingTabOdonto"
            :headers="headersOdonto"
            :cadastros="selectedItemModalOdonto"
          >
          </tabela>
        </b-tab>
        <b-tab
          title="Vacinas"
          @click="detalharCidadao(selectedItemToModal, 'vacinas')"
        >
          <div class="row c-select-indicator">
            <div class="col-sd-12 col-md-6 col-lg-5 col-xl-4">
              <vue-select
                :options="vacinas.items"
                label="label"
                placeholder="Indicador"
                v-model="vacinas.selected"
                @input="handlePeriodAndIndicator($event, vacinas.indicator)"
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela
            :loading="loadingTabVacinas"
            :headers="headersVacinas"
            :cadastros="selectedItemModalVacinas"
            :enabledSearch="true"
            labelSearch="Imuno ou Dose"
          >
          </tabela>
        </b-tab>
        <b-tab
          title="Procedimentos"
          @click="detalharCidadao(selectedItemToModal, 'procedimentos')"
        >
          <div class="row c-select-indicator">
            <div class="col-sd-12 col-md-6 col-lg-5 col-xl-4">
              <vue-select
                :options="procedimentos.items"
                label="label"
                placeholder="Período"
                v-model="procedimentos.selected"
                @input="
                  handlePeriodAndIndicator($event, procedimentos.indicator)
                "
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela
            :loading="loadingTabProcedimentos"
            :headers="headersProcedimentos"
            :cadastros="selectedItemModalProcedimentos"
          >
          </tabela>
        </b-tab>
        <b-tab
          title="Visitas"
          @click="detalharCidadao(selectedItemToModal, 'visitas')"
        >
          <tabela
            :loading="loadingTabVisitas"
            :headers="headersVisitas"
            :cadastros="selectedItemModalVisitas"
          >
          </tabela>
        </b-tab>
        <!-- <b-tab title="Agendamentos"><p>I'm a disabled tab!</p></b-tab> -->
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../components/Menu'
import Footer from '../../../components/Footer'
import SectionTitle from './SectionTitle'
import { mapState } from 'vuex'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import LoaderTableSkeleton from '../../../components/LoaderTableSkeleton.vue'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'
import Tabela from './Tabela.vue'
import store from '@/store/store'
import * as Functions from './functions.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'AcsPorCidadao',
  metaInfo: {
    title: 'eSUS Feedback - Cidadão',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    LoaderTableSkeleton,
    Pagination,
    Tabela,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },

    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      atendimentos: {
        indicator: 'atendimentos',
        selected: null,
        items: [{ label: 'Últimos 13 meses', value: 13 }],
      },
      odonto: {
        indicator: 'odonto',
        selected: null,
        items: [{ label: 'Últimos 13 meses', value: 13 }],
      },
      procedimentos: {
        indicator: 'procedimentos',
        selected: null,
        items: [
          { label: 'Últimos 13 meses', value: 13 },
          { label: 'Últimos 36 meses', value: 36 },
        ],
      },
      vacinas: {
        indicator: 'vacinas',
        selected: null,
        items: [
          {
            label: 'Penta e Vip',
            value: 13,
          },
        ],
        searchValues: ['Poliomielite inativada', 'DTP / HB / Hib'],
      },
      filterSearchTable: false,
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      termo: '',
      cns: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      dt_nascimento: '',
      selectedItemToModal: '',
      selectedItemModalCadastros: [],
      loadingTabCadastros: false,
      dataFields: {
        ...Functions.dataFields,
      },
      headersCidadao: [
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_cpf',
        },
        {
          text: '	IMPRIMIR CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_cns',
        },
        {
          text: 'NOME',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_cidadao',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'MÃE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_mae',
        },
        {
          text: 'AÇÃO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'action',
        },
      ],
      headersCadastros: [
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'ATUAL. GRUPO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_atualizacao',
        },

        {
          text: 'ID DW',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_dw',
        },
        {
          text: 'ID MASTER',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_master',
        },
        {
          text: 'ID PEC',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_pec',
        },
        {
          text: 'ID UNIFICADO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_unificado',
        },
      ],
      selectedItemModalAtendimentosOriginais: [],
      selectedItemModalAtendimentos: [],
      loadingTabAtendimentos: false,
      headersAtendimentos: [
        {
          text: 'CFCP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'ATENDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_atendimento',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'tipo',
        },
      ],
      selectedItemModalOdontoOriginais: [],
      selectedItemModalOdonto: [],
      loadingTabOdonto: false,
      headersOdonto: [
        {
          text: 'CFCP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'ATENDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_atendimento',
        },
        {
          text: 'GESTANTE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'gestante',
        },
      ],
      selectedItemModalVacinasOriginais: [],
      selectedItemModalVacinas: [],
      loadingTabVacinas: false,
      headersVacinas: [
        {
          text: 'CFCP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cfcp',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'IMUNO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_imuno',
        },
        {
          text: 'DOSE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_dose_imuno',
        },
        {
          text: 'APLICAÇÃO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_aplicacao_br',
        },
        {
          text: 'DOSE ANTERIOR',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dose_anterior',
        },
      ],
      selectedItemModalProcedimentosOriginais: [],
      selectedItemModalProcedimentos: [],
      loadingTabProcedimentos: false,
      headersProcedimentos: [
        {
          text: 'CFCP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_procedimento',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'tipo',
        },
      ],
      selectedItemModalVisitas: [],
      loadingTabVisitas: false,
      headersVisitas: [
        {
          text: 'CFCP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'VISITADO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_visita',
        },
        {
          text: 'TURNO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'turno',
        },
        {
          text: 'DESFECHO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'desfecho',
        },
      ],
    }
  },
  methods: {
    resetFilter(indicator) {
      switch (indicator) {
        case 'atendimentos':
          this.selectedItemModalAtendimentos =
            this.selectedItemModalAtendimentosOriginais
          break
        case 'odonto':
          this.selectedItemModalOdonto = this.selectedItemModalOdontoOriginais
          break
        case 'procedimentos':
          this.selectedItemModalProcedimentos =
            this.selectedItemModalProcedimentosOriginais
          break
        case 'vacinas':
          this.selectedItemModalVacinas = this.selectedItemModalVacinasOriginais
          break
        default:
          ''
          break
      }
    },
    handlePeriodAndIndicator(item, indicator) {
      this.resetFilter(indicator)
      if (item === null) {
        return
      }
      const months = item.value
      switch (indicator) {
        case 'atendimentos':
          this.selectedItemModalAtendimentos = this.filterPeriodMonths(
            months,
            this.selectedItemModalAtendimentos,
            'dt_atendimento'
          )
          break
        case 'odonto':
          this.selectedItemModalOdonto = this.filterPeriodMonths(
            months,
            this.selectedItemModalOdonto,
            'dt_atendimento'
          )
          break
        case 'procedimentos':
          this.selectedItemModalProcedimentos = this.filterPeriodMonths(
            months,
            this.selectedItemModalProcedimentos,
            'dt_procedimento'
          )
          break
        case 'vacinas':
          this.selectedItemModalVacinas = this.filterIndicator(
            this.selectedItemModalVacinas,
            'no_imuno',
            this.vacinas.searchValues
          )
          break
        default:
          break
      }
    },
    filterIndicator(arrayToFilter, propertyName, searchValues) {
      let filteredData = arrayToFilter.filter((item) => {
        return searchValues.some((value) => item[propertyName].includes(value))
      })
      return filteredData
    },
    diffMonthsFromDate(date) {
      const [year, month, day] = date.split('-')
      const startDate = new Date(year, month - 1, day)

      let today = new Date()
      let months = (today.getFullYear() - startDate.getFullYear()) * 12
      months -= startDate.getMonth()
      months += today.getMonth()

      return months
    },

    filterPeriodMonths(periodMonths, arrayToFilter, datePropertyName) {
      let filteredData = arrayToFilter.filter((item) => {
        let itemDate = item[datePropertyName]
        let monthsDiff = this.diffMonthsFromDate(itemDate)
        return monthsDiff <= periodMonths
      })

      return filteredData
    },
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async detalharCidadao(item, route) {
      try {
        this.selectedItemToModal = item
        this.$bvModal.show('modal-acs-cidadao')

        let url = ''

        switch (route) {
          case 'cadastros':
            this.loadingTabCadastros = true
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${item.nu_cns}/cadastros`
            break
          case 'atendimentos':
            this.loadingTabAtendimentos = true
            let itemsCns = this.selectedItemModalCadastros.map(
              (item) => item.cns
            )
            let urlCns = ''
            if (itemsCns.length == 1 && itemsCns[0] == null) {
              urlCns = '0'
            } else {
              urlCns = itemsCns.filter((el) => el !== null).join(',')
            }
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${urlCns}/atendimentos`
            break
          case 'odonto':
            this.loadingTabOdonto = true
            let itemsCns2 = this.selectedItemModalCadastros.map(
              (item) => item.cns
            )
            let urlCns2 = ''
            if (itemsCns2.length == 1 && itemsCns2[0] == null) {
              urlCns2 = '0'
            } else {
              urlCns2 = itemsCns2.filter((el) => el !== null).join(',')
            }
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${urlCns2}/odonto`
            break
          case 'vacinas':
            this.loadingTabVacinas = true
            let itemsCns3 = this.selectedItemModalCadastros.map(
              (item) => item.cns
            )
            let urlCns3 = ''
            if (itemsCns3.length == 1 && itemsCns3[0] == null) {
              urlCns3 = '0'
            } else {
              urlCns3 = itemsCns3.filter((el) => el !== null).join(',')
            }
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${urlCns3}/vacinas`
            break
          case 'procedimentos':
            this.loadingTabProcedimentos = true
            let itemsCns4 = this.selectedItemModalCadastros.map(
              (item) => item.cns
            )
            let urlCns4 = ''
            if (itemsCns4.length == 1 && itemsCns4[0] == null) {
              urlCns4 = '0'
            } else {
              urlCns4 = itemsCns4.filter((el) => el !== null).join(',')
            }
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${urlCns4}/procedimentos`
            break
          case 'visitas':
            this.loadingTabVisitas = true
            let itemsCns5 = this.selectedItemModalCadastros.map(
              (item) => item.cns
            )
            let urlCns5 = ''
            if (itemsCns5.length == 1 && itemsCns5[0] == null) {
              urlCns5 = '0'
            } else {
              urlCns5 = itemsCns5.filter((el) => el !== null).join(',')
            }
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${urlCns5}/visitas`
            break
          default:
            this.loadingTabCadastros = true
            url = `/app/acs-por-cidadao/${this.cod_ibge}/${item.nu_cpf}/${item.nu_cns}/cadastros`
            break
        }

        const response = await this.$api.get(url)
        if (response) {
          switch (route) {
            case 'cadastros':
              this.selectedItemModalCadastros = response.data
              break
            case 'atendimentos':
              this.atendimentos.selected = null
              this.selectedItemModalAtendimentosOriginais = response.data
              this.selectedItemModalAtendimentos = response.data
              break
            case 'odonto':
              this.odonto.selected = null
              this.selectedItemModalOdontoOriginais = response.data
              this.selectedItemModalOdonto = response.data
              break
            case 'vacinas':
              this.vacinas.selected = null
              this.selectedItemModalVacinasOriginais = response.data
              this.selectedItemModalVacinas = response.data
              break
            case 'procedimentos':
              this.procedimentos.selected = null
              this.selectedItemModalProcedimentosOriginais = response.data
              this.selectedItemModalProcedimentos = response.data
              break
            case 'visitas':
              this.selectedItemModalVisitas = response.data
              break
            default:
              this.selectedItemModalCadastros = response.data
              break
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        switch (route) {
          case 'cadastros':
            this.loadingTabCadastros = false
            break
          case 'atendimentos':
            this.loadingTabAtendimentos = false
            break
          case 'odonto':
            this.loadingTabOdonto = false
            break
          case 'vacinas':
            this.loadingTabVacinas = false
            break
          case 'procedimentos':
            this.loadingTabProcedimentos = false
            break
          case 'visitas':
            this.loadingTabVisitas = false
            break
          default:
            this.loadingTabCadastros = false
            break
        }
      }
    },

    excluirCadastro(item) {
      let rsp = confirm('Deseja excluir este cadastro?')
      if (rsp == true) {
        let url = '/app/acs-por-cidadao/excluir/' + this.cod_ibge
        this.$api
          .post(url, {
            id: item.id,
          })
          .then((response) => {
            if (response.data.error == true) {
              this.$toast.error(response.data.message, 'Error:', {
                position: 'topRight',
              })
            } else {
              this.$toast.success(response.data.message, 'Sucesso:', {
                position: 'topRight',
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },

    buscarAcsPorCidadao() {
      if (this.termo != '') {
        this.loading = true

        let url = '/app/acs-por-cidadao/' + this.cod_ibge + '/' + this.termo
        if (this.dt_nascimento !== '') {
          url += `/${this.dt_nascimento}`
        }

        this.$api
          .get(url)
          .then((response) => {
            this.loading = false
            this.cadastros = response.data
          })
          .catch(function (error) {
            console.log(error)
            this.loading = false
          })
      } else {
        this.$toast.error('Digite um nome ou CPF!', 'Error:', {
          position: 'topRight',
        })
      }
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros)
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
#acs-por-cidadao .btn-submit {
  margin-top: 30px;
  color: #fff;
}

#modal-acs-cidadao .modal-content {
  border-radius: 0.8rem;
}

#modal-acs-cidadao .tabs {
  margin-top: 40px;
}

#modal-acs-cidadao .nav-tabs {
  border-bottom: none;
}

#modal-acs-cidadao .nav-tabs .nav-link {
  text-transform: capitalize !important;
  border-color: #fff !important;
}

#modal-acs-cidadao .nav-tabs .nav-link.active {
  border-color: #dee2e6 #dee2e6 #dee2e6 !important;
}

#modal-acs-cidadao .tabs .tab-content {
  margin-top: 0 !important;
}

#modal-acs-cidadao .card {
  padding: 0 !important;
}

@media screen and (max-width: 656px) {
  #acs-por-cidadao .btn-submit {
    margin-top: 0px;
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  #acs-por-cidadao .btn-submit {
    margin-top: 0px;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  #acs-por-cidadao .btn-submit {
    margin-top: 0px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
  #acs-por-cidadao .btn-submit {
    margin-top: 30px;
  }
}
</style>
<style scoped>
.c-select-indicator {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
